import { createStyles, makeStyles } from '@material-ui/styles';
import * as classNames from 'classnames';
import * as React from 'react';
import { FC } from 'react';
import mediaQueries from 'src/constants/responsive';
import spacing from 'src/constants/spacing';
import stylesheet from 'src/constants/stylesheet';
import ViewMonitor from 'src/utils/ViewMonitor';

const useStyles = makeStyles(() =>
  createStyles({
    textContainer: {
      position: 'relative',
      width: '100%',

      [mediaQueries.Mobile]: {
        paddingLeft: spacing.GutterGrid.Mobile / 2,
        paddingRight: spacing.GutterGrid.Mobile / 2,

        paddingBottom: spacing.Gutter.Mobile / 2,
      },
      [mediaQueries.Tablet]: {
        paddingLeft: spacing.GutterGrid.Tablet / 2,
        paddingRight: spacing.GutterGrid.Tablet / 2,

        paddingBottom: spacing.Gutter.Tablet / 2,
      },
      [mediaQueries.Laptop]: {
        paddingLeft: spacing.GutterGrid.Laptop / 2,
        paddingRight: spacing.GutterGrid.Laptop / 2,

        paddingBottom: spacing.Gutter.Laptop / 2,
      },
      [mediaQueries.Desktop]: {
        paddingLeft: spacing.GutterGrid.Desktop / 2,
        paddingRight: spacing.GutterGrid.Desktop / 2,

        paddingBottom: spacing.Gutter.Desktop / 2,
      },
      [mediaQueries.BigDesktop]: {
        width: `${2 / 3 * 100}%`,
        marginLeft: 'auto',
        paddingLeft: spacing.GutterGrid.BigDesktop / 2,
        paddingRight: spacing.GutterGrid.BigDesktop / 2,

        paddingBottom: spacing.Gutter.BigDesktop / 2,
      }
    },
    textContainerInner: {
      [mediaQueries.Mobile]: {
        width: '100%',
      },
      [mediaQueries.Tablet]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.Laptop]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.Desktop]: {
        maxWidth: spacing.panelTextMaxWidth.Small,
      },
      [mediaQueries.BigDesktop]: {
        maxWidth: spacing.panelTextMaxWidth.Big,
      }
    },
    hide: {
      ...stylesheet.Hide,
      transitionDelay: '100ms'
    },
    show: {
      ...stylesheet.Show
    }
  }));

export type PanelText = PanelTextDto;
type Props = PanelText;

const PanelText: FC<Props> = ({ Text, children }) => {
  const cls = useStyles();

  return (
    <div className={cls.textContainer}>
      <ViewMonitor once={true}>{(intersect) =>
        <div
          className={classNames(cls.textContainerInner, cls.hide, intersect && cls.show)}
          dangerouslySetInnerHTML={{ __html: Text }}
        />
      }</ViewMonitor>
      {children}
    </div>
  );
};

export default PanelText;


// WEBPACK FOOTER //
// ./src/Components/Panels/PanelText.tsx